import { createAction } from 'redux-actions'


// Actions
export const UPDATE_LOADS = 'customerPortal/loadsToday/UPDATE_LOADS'
export const UPDATE_TOTAL = 'customerPortal/loadsToday/UPDATE_TOTAL'
export const UPDATE_MODIFIED_LOADS = 'customerPortal/loadsToday/UPDATE_MODIFIED_LOADS'
export const UPDATE_SORT_FIELD = 'customerPortal/loadsToday/UPDATE_SORT_FIELD'
export const TOGGLE_SORT_DIRECTION = 'customerPortal/loadsToday/TOGGLE_SORT_DIRECTION'
export const SET_SORT_DIRECTION = 'customerPortal/loadsToday/SET_SORT_DIRECTION'
export const RESET = 'customerPortal/loadsToday/RESET'

const initialState = {
  title: `Today`,
  loads: [],
  total: 0,
  status: ``,
  modifiedLoads: [],
  sortField: `pickupDate`,
  direction: `desc`
}

// Reducer
export default function loadsToday (state = initialState, action) {
  switch (action.type) {
    case UPDATE_LOADS:
      return {
        ...state,
        loads: action.payload
      }
    case UPDATE_TOTAL:
      return {
        ...state,
        total: action.payload
      }
    case UPDATE_MODIFIED_LOADS:
      return {
        ...state,
        modifiedLoads: action.payload
      }
    case UPDATE_SORT_FIELD:
      return {
        ...state,
        sortField: action.payload,
        direction: `desc`
      }
    case TOGGLE_SORT_DIRECTION:
      return {
        ...state,
        direction: state.direction === `asc` ? `desc` : `asc`
      }
    case SET_SORT_DIRECTION:
      return {
        ...state,
        direction: action.payload
      }
    case RESET:
      return initialState
    default:
      return state
  }
}

// Action Creators
export const updateLoadsToday = createAction(UPDATE_LOADS)
export const updateTotalLoadsToday = createAction(UPDATE_TOTAL)
export const updateModifiedLoadsToday = createAction(UPDATE_MODIFIED_LOADS)
export const updateSortFieldLoadsToday = createAction(UPDATE_SORT_FIELD)
export const toggleSortDirectionLoadsToday = createAction(TOGGLE_SORT_DIRECTION)
export const setSortDirectionLoadsToday = createAction(SET_SORT_DIRECTION)
export const resetLoadsToday = createAction(RESET)